import * as React from 'react';
import { Button, Col, Row } from 'reactstrap';
import {
  IGlobalContextProps,
  withGlobalContext,
} from 'src/context/global.context';
import { deleteProfilePicture, uploadProfilePicture } from 'src/services';

export const ProfilePictureInput: React.SFC<IGlobalContextProps> = ({
  context,
}) => {
  const fileInputRef = React.createRef();
  const { user, updateUser } = context;
  const [pictureUrl, setPictureUrl] = React.useState(
    user &&
      user.profile &&
      user.profile.picture &&
      user.profile.picture.pictureUrl
  );

  const openProfilePictureDialog = () => {
    if (fileInputRef) {
      (fileInputRef as any).current.click();
    }
  };

  const handleChange = async (e: React.ChangeEvent<Element>) => {
    const file = (e.target as any).files[0];
    const uploadedProfilePicture = await uploadProfilePicture(file);
    if (uploadedProfilePicture) {
      setPictureUrl(uploadedProfilePicture.pictureUrl);
      updateUser();
    }
  };

  const handleDelete = async () => {
    const deletedProfilePicture = await deleteProfilePicture();
    if (deletedProfilePicture) {
      setPictureUrl('');
      updateUser();
    }
  };

  return (
    <Row>
      <Col md='6' xs='auto'>
        {pictureUrl ? (
          <img
            className='d-block rounded-circle'
            src={pictureUrl}
            style={{ height: '120px', width: '120px' }}
          />
        ) : (
          <div
            className='d-flex justify-content-center align-items-center rounded-circle font-weight-bold text-center text-white bg-dark mr-4'
            style={{ fontSize: '18px', height: '120px', width: '120px' }}
          >
            Photo
            <br />
            ou
            <br />
            logotype
          </div>
        )}
      </Col>
      <Col md='6' xs='auto' className='d-flex flex-column'>
        <Button
          className='text-white text-uppercase bg-secondary border-0 mt-3 w-100'
          onClick={openProfilePictureDialog}
        >
          Charger
        </Button>
        <Button
          className='text-white text-uppercase bg-dark border-0 mt-3 w-100'
          onClick={handleDelete}
        >
          Supprimer
        </Button>
      </Col>
      <input
        accept='image/jpeg, image/png'
        type='file'
        ref={fileInputRef as any}
        onChange={handleChange}
        style={{ display: 'none' }}
      />
    </Row>
  );
};

export const ProfilePictureInputWithGlobalContext = withGlobalContext(
  ProfilePictureInput
);



// WEBPACK FOOTER //
// ./src/components/Profile/ProfilePicture/ProfilePictureInput.tsx